import { html } from "../../render";
import { cn, safeRandomId, spreadAttrs } from "../../utils";
import { LpButton } from "../../components/button";
import { LpDropdownMenu } from "../../components/dropdown";
import { LpLayerCard, LpLayerCardPrimary, LpLayerCardSecondary, } from "../../components/layer-card";
import { LpTable } from "../../components/table";
const managedAttrs = [
    "data-lp-block",
    "class",
    "role",
    "aria-labelledby",
];
function renderColumnMenu(columns) {
    const editableColumns = columns.filter((column) => !column.required);
    return LpDropdownMenu.Root({
        className: "lp-data-table_columns",
        trigger: (context) => LpDropdownMenu.Trigger({
            ...context,
            label: "Display options",
            prefixIcon: "gear-six",
            size: "sm",
            variant: "secondary",
        }),
        content: (context) => LpDropdownMenu.Content({
            ...context,
            label: "Edit table columns",
            align: "end",
            className: "lp-data-table_columns-menu",
            children: LpDropdownMenu.Group({
                children: (groupContext) => html `
                    ${LpDropdownMenu.Label({
                    ...groupContext,
                    children: "Edit columns",
                    action: LpButton({
                        label: "Reset",
                        size: "sm",
                        variant: "ghost",
                        disabled: true,
                        attributes: { "data-lp-data-table-columns-reset": true },
                    }),
                })}
                    ${editableColumns.map((column) => LpDropdownMenu.CheckboxItem({
                    label: column.label,
                    checked: column.visibleByDefault !== false,
                    value: column.key,
                    attributes: {
                        ...column.menuAttributes,
                        "data-lp-data-table-column-option": true,
                        "data-default-visible": column.visibleByDefault !== false
                            ? "true"
                            : "false",
                    },
                }))}
                `,
            }),
        }),
    });
}
export function LpDataTable({ title, caption, columns, children, footer, summary, actions, notice, noticeAttributes, showColumnMenu = true, stickyHeader = false, className, attributes, }) {
    const titleId = `lp-data-table-title-${safeRandomId()}`;
    const cardActions = showColumnMenu || actions
        ? html `${showColumnMenu ? renderColumnMenu(columns) : ""}${actions}`
        : undefined;
    return html `
        <lp-data-table
            data-lp-block="DataTable"
            class="${cn("lp-data-table", className, attributes?.class)}"
            role="region"
            aria-labelledby="${titleId}"
            ${spreadAttrs(attributes, { omit: managedAttrs })}
        >
            ${LpLayerCard({
        children: html `
                    ${LpLayerCardSecondary({
            className: "lp-data-table_layer-secondary",
            children: html `
                            <h2 class="lp-data-table_layer-title" id="${titleId}">${title}</h2>
                            ${cardActions
                ? html `<div class="lp-data-table_layer-actions">${cardActions}</div>`
                : ""}
                        `,
        })}
                    ${LpLayerCardPrimary({
            padding: "none",
            className: "lp-data-table_layer-primary",
            children: html `
                            ${notice
                ? html `
                                    <div
                                        class="${cn("lp-data-table_notice", noticeAttributes?.class)}"
                                        ${spreadAttrs(noticeAttributes, { omit: ["class"] })}
                                    >${notice}</div>
                                `
                : ""}
                            ${LpTable.Root({
                caption,
                columns,
                children: html `
                                    ${LpTable.Header({
                    sticky: stickyHeader,
                    children: LpTable.Row({
                        className: "lp-table_header-row",
                        children: columns.map((column) => LpTable.Head({ column })),
                    }),
                })}
                                    ${children}
                                    ${footer}
                                `,
            })}
                            ${summary
                ? html `
                                    <footer class="lp-data-table_summary-footer">
                                        <div class="lp-data-table_summary" role="status">${summary}</div>
                                    </footer>
                                `
                : ""}
                        `,
        })}
                `,
    })}
        </lp-data-table>
    `;
}
